import React, { useCallback, useState } from 'react';
import { ActivityIndicator } from 'react-native';
import { Button, withTheme } from '@rneui/themed';
import { PlaybackEvent, PlaybackEventEmitter, usePlaylistStateStore } from '@annunciate/core';
import { FAIcon, View } from '../../elements';
const promoteAvailablePlaylist = usePlaylistStateStore.getState().promoteAvailablePlaylist;
export const UnthemedPlayCollectionButton = ({ iconColor, iconContainerStyle, }) => {
    const [isLoading, setIsLoading] = useState(false);
    const onPlayPressed = useCallback(async () => {
        setIsLoading(true);
        await promoteAvailablePlaylist();
        await PlaybackEventEmitter.emit(PlaybackEvent.ATTEMPT_ADVANCE_PLAYLIST, 0);
        setIsLoading(false);
    }, []);
    return (React.createElement(Button, { onPress: onPlayPressed },
        React.createElement(View, { style: iconContainerStyle }, isLoading ? (React.createElement(ActivityIndicator, { color: iconColor })) : (React.createElement(FAIcon, { name: "play", color: iconColor }))),
        "Play All"));
};
export const PlayCollectionButton = withTheme(UnthemedPlayCollectionButton, 'PlayCollectionButton');
//# sourceMappingURL=PlayCollectionButton.js.map